import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    background: ${COLORS.white};
    margin-bottom: -50px;
    padding: 0 7%;
`;

export const Container = styled.div`
    flex-direction: column;
    margin: 80px auto;
    margin-bottom: 100px;
    width: 100%;
    max-width: 985px;
    min-width: 421px;

    @media (max-width: 768px) {
      min-width: auto;
    }
`;

export const Header = styled.h1`
    ${FONTS.H2};
    @media (min-width: 640px) {
        ${FONTS.H1};
        margin-top: 70px;
        margin-bottom: 40px;
    }
`;

export const SubHeader = styled.h2`
    margin-bottom: 20px;
    ${FONTS.H2};
    @media (max-width: 640px) {
        ${FONTS.H4};
    }

`;

export const Text = styled.p`
    ${FONTS.S};
    margin-bottom: 20px;
`;

export const Button = styled(BaseButton)`
    width: fit-content;
    margin-bottom: 60px;

    @media (max-width: 640px) {
        margin-bottom: 30px;
    }
`;
